export default "__VITE_ASSET__ssadRT2s__"